import { IconSize } from '@constants';
import { Box, styled } from '@mui/material';

interface VideoThumbnailContainerStyledProps {
  isSelected?: boolean;
}
export const VideoThumbnailContainerStyled = styled(
  'div',
)<VideoThumbnailContainerStyledProps>(({ theme, isSelected }) => ({
  borderRadius: theme.spacing(0.5),
  border: isSelected ? `2px solid ${theme.palette.primary.main}` : '',
  borderColor: isSelected ? theme.palette.primary.main : 'transparent',

  height: 110,
  overflow: 'hidden',
  cursor: 'pointer',
  position: 'relative',
  maxWidth: 200,
  '& img': { maxWidth: '100%', height: '100%' },
}));

export const CheckMarkStyled = styled(Box)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  bottom: 12,
  left: 12,
  background: theme.palette.primary.main,

  borderRadius: '50%',
  height: IconSize.md,
  width: IconSize.md,
}));
